import Vue from "vue";
import { Component } from "vue-property-decorator";
import { WishListContainer } from "../containers";

@Component({
    components: { WishListContainer },
})
export default class MainView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    options: orgmap.TWishContainerOptionItem[] = [
        {
            id: 0,
            name: this.$t("받는사람").toString(),
            height: "40%",
        },
        {
            id: 1,
            name: this.$t("참조").toString(),
            height: "30%",
        },
        {
            id: 2,
            name: this.$t("숨은참조").toString(),
            height: "30%",
        },
    ];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    handleOk() {
        console.log("clicked ok button.");
    }

    handleCancel() {
        console.log("clicked cancel button.");
    }
}
